//Dark Colors
const black_pearl = "#091A2D";
const black_pearl_translucent = "rgba(9, 26, 45, 0.8)";
const black_pearl_dark = "#071422";
const black_pearl_dark_translucent = "rgba(7, 20, 34, 0.9)";
const black_pearl_darker = "#040E19";
const silver = "#C1C1C1";
const astronaut = "#26486E";
const polo_blue = "#87A8D8";
const bismark = "#416183";

//Light Colors
const ebb = "#E8DBDB";
const ebb_translucent = "rgba(232,219,219,0.5)";
const vista_white = "#F8EDED";
const vista_white_translucent = "rgba(248,237,237,0.9)";
const ship_gray = "#413446";
const botticelli = "#CAD5E5";
const black_pearl_light = "#041A2F";

//Common Colors
const royal_blue = "#455EE5";
const sunglo = "#E26A71";
const white = "#FFFFFF";
const black = "#000000";
const mortar = "#5A4E5E";
const ming = "#2E7074";
const danube = "#6678D1";
const dove_gray = "#707070";

export const theme = {
  white: "#FFFFFF",
  secondaryText: "#C1C1C1",
  disabledText: "#707070",
  dayMode: {
    color1: "#413446",
    color2: "#CAD5E4",
    color3: "#2E7074",
    color4: "#E8DBDB",
    color5: "#F8EDED",
    color6: "#E26B05",
    color7: "#E26A71",
    color8: "#6678D1"
  },
  nightMode: {
    color1: "#091A2D",
    color2: "#071422",
    color3: "#2E7074",
    color4: "#040E19",
    color5: "#87A8D8",
    color6: "#E26B05",
    color7: "#E26A71",
    color8: "#6678D1",
    color9: "#455EE5",
    tweetReplyBackground: "#26486E"
  }
};

export default {
  dark: {
    primary: royal_blue,
    buttonPrimary: royal_blue,
    buttonSecondary: ming,
    background: black_pearl,
    backgroundSecondary: black_pearl_dark,
    backgroundSecondaryTranslucent: black_pearl_dark_translucent,
    backgroundTertiary: black_pearl_darker,
    text: silver,
    textHighlight: white,
    tweetLogoCircle: ming,
    tweetBackground: astronaut,
    icon: white,
    iconInner: black_pearl_light,
    mapOptions: black_pearl_translucent,
    mapPopup: polo_blue,
    mapPopupClose: danube,
    mapMarker: sunglo,
    disabledText: dove_gray,
    closeRed: sunglo,
    border: bismark,
    white
  },
  light: {
    primary: ming,
    buttonPrimary: sunglo,
    buttonSecondary: ming,
    background: ebb,
    backgroundSecondary: vista_white,
    backgroundSecondaryTranslucent: vista_white_translucent,
    backgroundTertiary: ebb,
    text: ship_gray,
    textHighlight: mortar,
    tweetLogoCircle: mortar,
    tweetBackground: botticelli,
    icon: ship_gray,
    iconInner: white,
    mapOptions: ebb_translucent,
    mapPopup: botticelli,
    mapPopupClose: sunglo,
    mapMarker: danube,
    disabledText: dove_gray,
    closeRed: sunglo,
    border: bismark,
    white
  }
};
